/** Az adott weboldal/app IFrame-ben fut? */
export default function isInIframe (): boolean {
  try {
    return window.self !== window.top
  }
  catch {
    return true
  }
}
